'use client'

import { createMedia } from '@artsy/fresnel'

const AppMedia = createMedia({
  breakpoints: {
    xs: 0,
    sm: 413,
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1536
  }
})

const { MediaContextProvider, Media } = AppMedia

export const mediaStyles = AppMedia.createMediaStyle()

export { MediaContextProvider, Media }
